module.exports = __webpack_public_path__ + "static/media/Sharp-LS044Q7DH01-Mechanical-Drawing.725bf35a.png";